import createIcon from '../../createIcon';

/**
 * @component @name TextFields
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDQuNVY3LjVINy41VjE5LjVIMTAuNVY3LjVIMTUuNVY0LjVIMi41Wk0yMS41IDkuNUgxMi41VjEyLjVIMTUuNVYxOS41SDE4LjVWMTIuNUgyMS41VjkuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextFields = createIcon('TextFields', [
  [
    'path',
    {
      d: 'M2.5 4.5V7.5H7.5V19.5H10.5V7.5H15.5V4.5H2.5ZM21.5 9.5H12.5V12.5H15.5V19.5H18.5V12.5H21.5V9.5Z',
      key: '5pt8e0',
    },
  ],
]);

export default TextFields;
